import { lazy } from 'react';

const paymentRoutes = [
    {
        exact: true,
        path: '/payments',
        component: lazy(() => import('../views/payments'))
    },
    {
        exact: true,
        path: '/FleetSuccess',
        component: lazy(() => import('../views/PaymentSuccess'))
    },
    {
        exact: true,
        path: '/FleetFailed',
        component: lazy(() => import('../views/PaymentFailed'))
    },
    {
        exact: true,
        path: '/PaymentFailed',
        component: lazy(() => import('../views/PaymentFailed'))
    },
    {
        exact: true,
        path: '/PaymentSuccess',
        component: lazy(() => import('../views/PaymentSuccess'))
    },
    {
        exact: true,
        path: '/SellersTab',
        component: lazy(() => import('../views/payments/SellersTab/SellersMainTab'))
    }
];

export default paymentRoutes;
